module.exports = __webpack_public_path__ + "img/onexus-dark.82ff0c90.png";